export const PHONE_FORMAT = /^[+]?[0-9]([0-9]?[-\s]?)+[0-9]$/g;
